import PublicDataTable from '../PublicDataTable';
import ContactCell from '../ContactCell';
import StatusBadge from './OperationalStatusBadge';

// Feed & Nutrition, Cold Chain & Logistics and Breeding & Genetic Improvement
// tables — column order from their designs. Breeding titles the `type`
// column "Category"; the other two call it "Facility Type".
const columns = (typeTitle) => [
  { key: 'name',      title: 'Name' },
  { key: 'contact',   title: 'Contact', render: (v) => <ContactCell number={v} /> },
  { key: 'type',      title: typeTitle },
  { key: 'ownership', title: 'Ownership' },
  { key: 'species',   title: 'Source Species' },
  { key: 'products',  title: 'Products Processed' },
  {
    key: 'capacity',
    title: 'Capacity',
    render: (v) => (v != null ? Number(v).toLocaleString('en-NG') : '—'),
  },
  { key: 'unit',      title: 'Unit' },
  { key: 'status',    title: 'Operational Status', render: (v) => <StatusBadge status={v || '—'} /> },
];

export default function CentresTable({ rows, searchQuery, tableKey, typeTitle = 'Facility Type' }) {
  return <PublicDataTable key={tableKey} columns={columns(typeTitle)} data={rows} searchQuery={searchQuery} pageSize={10} />;
}
